import React from 'react'

const AppDashboard = () => {
    return (
        <div>
            <h1>App Dashboard</h1>
        </div>
    )
}

export default AppDashboard
